/**
 * `/projects/new` — non è più una pagina.
 *
 * La creazione commessa è una **modale** sulla lista (`features/projects/NewProjectModal`):
 * si parte dalla lista e ci si torna subito dopo, senza perdere filtri e scroll. Questa
 * rotta resta per i link e i preferiti esistenti e reindirizza a `/projects?new=1`, che
 * apre la modale.
 */
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/projects/new')({
  beforeLoad: () => {
    throw redirect({ to: '/projects', search: { new: true } });
  },
});
